import { Component, DoCheck, ElementRef, HostListener, NgZone, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { IonSlides } from '@ionic/angular';
import { ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { ActivatedRoute } from '@angular/router';
import { FormServiceService } from 'src/app/services/publications/form-service.service';
import { Utils } from 'src/app/Models/Classes/utils';
import { AppNavigationStateService } from 'src/app/services/startup/app-navigation-state.service';


type TrailerItem = {
  title: string;
  youtubeUrl: string;
  poster: string;
  embedUrl?: SafeResourceUrl;
};

@Component({
  selector: 'app-lkfilm-studios',
  templateUrl: './lkfilm-studios.component.html',
  styleUrls: ['./lkfilm-studios.component.scss'],
})
export class LkfilmStudiosComponent implements OnInit, AfterViewInit, OnDestroy, DoCheck {
  @ViewChild(IonSlides) slides: IonSlides;
  @ViewChild(IonSlides, { read: ElementRef, static: false }) slidesEl!: ElementRef;
  private wheelLock = false;
  private wheelCleanup?: () => void;
  private touchCleanup?: () => void;
  private touchStartY: number | null = null;
  private touchCurrentY: number | null = null;

  slideOpts: any = {
  direction: 'vertical',
  initialSlide: 0,
    speed: 699,         // a bit lower → fewer GPU spikes
  loop: false,                // safer on iOS (no DOM cloning)
  effect: 'slide',            // keep it basic
  threshold: 10,              // need a real swipe to start
  resistanceRatio: 0.65,      // less rubber-banding
  preventInteractionOnTransition: true, // ignore swipes until animation ends
  touchReleaseOnEdges: true,
  observer: true,
  observeParents: true,
  // If your IonSlides/Swiper version supports it, this is the most stable:
  // cssMode: true,           // native scroll; comment out if you get an unknown option error
  lazy: true,                 // only load what’s needed
};
trailers: TrailerItem[] = [
  {
    title: `The Shawshank Redemption`,
    youtubeUrl: 'https://www.youtube.com/watch?v=xyXX8LXiNJ4',
    poster: 'https://img.reelgood.com/content/movie/900bc451-e61f-48db-96c7-32b6635a3f75/poster-780.jpg',
  },
  {
    title: `The Dark Knight`,
    youtubeUrl: 'https://www.youtube.com/watch?v=kmJLuwP3MbY',
    poster: 'https://img.reelgood.com/content/movie/d6822b7b-48bb-4b78-ad5e-9ba04c517ec8/poster-780.jpg',
  },
  {
    title: `The Godfather`,
    youtubeUrl: 'https://www.youtube.com/watch?v=Ew9ngL1GZvs',
    poster: 'https://img.reelgood.com/content/movie/86307584-c177-4967-bf7e-8c5dc1afaa97/poster-780.jpg',
  },
  {
    title: `The Matrix`,
    youtubeUrl: 'https://www.youtube.com/watch?v=nUEQNVV3Gfs',
    poster: 'https://img.reelgood.com/content/movie/6eb67f3f-113d-47e6-8776-406dda49f7ca/poster-780.jpg',
  },
  {
    title: `The Lord of the Rings: The Return of the King`,
    youtubeUrl: 'https://www.youtube.com/watch?v=zckJCxYxn1g',
    poster: 'https://img.reelgood.com/content/movie/2c947f66-ba1e-4747-91a3-ab1432f6bb96/poster-780.jpg',
  },
  {
    title: `Inception`,
    youtubeUrl: 'https://www.youtube.com/watch?v=cdx31ak4KbQ',
    poster: 'https://img.reelgood.com/content/movie/2208ea58-f84f-48ed-b387-13dd836dc446/poster-780.jpg',
  },
  {
    title: `The Lord of the Rings: The Fellowship of the Ring`,
    youtubeUrl: 'https://www.youtube.com/watch?v=_nZdmwHrcnw',
    poster: 'https://img.reelgood.com/content/movie/266c407e-1a6d-4eb0-b3ad-0517114cf861/poster-780.jpg',
  },
  {
    title: `Fight Club`,
    youtubeUrl: 'https://www.youtube.com/watch?v=dfeUzm6KF4g',
    poster: 'https://img.reelgood.com/content/movie/1f276b93-2e3e-485b-9b9b-ea59cbd2ee98/poster-780.jpg',
  },
  {
    title: `Forrest Gump`,
    youtubeUrl: 'https://www.youtube.com/watch?v=bLvqoHBptjg',
    poster: 'https://img.reelgood.com/content/movie/40071990-6584-4a5a-8915-347c6b9cec3f/poster-780.jpg',
  },
  {
    title: `The Lord of the Rings: The Two Towers`,
    youtubeUrl: 'https://www.youtube.com/watch?v=nuTU5XcZTLA',
    poster: 'https://img.reelgood.com/content/movie/26c469f8-9fe2-4369-a5af-46c3d808bbf6/poster-780.jpg',
  },
  {
    title: `Interstellar`,
    youtubeUrl: 'https://www.youtube.com/watch?v=zSWdZVtXT7E',
    poster: 'https://img.reelgood.com/content/movie/2b222a79-d0fc-4c6b-b31b-44780d865bc0/poster-780.jpg',
  },
  {
    title: `Schindler's List`,
    youtubeUrl: 'https://www.youtube.com/watch?v=mxphAlJID9U',
    poster: 'https://img.reelgood.com/content/movie/4ec83f0e-eede-4453-8f87-461525e21f6e/poster-780.jpg',
  },
  {
    title: `Back to the Future`,
    youtubeUrl: 'https://www.youtube.com/watch?v=qvsgGtivCgs',
    poster: 'https://img.reelgood.com/content/movie/667a030c-a4dc-4c34-8577-6898478ab435/poster-780.jpg',
  },
  {
    title: `Seven`,
    youtubeUrl: 'https://www.youtube.com/watch?v=znmZoVkCjpI',
    poster: 'https://img.reelgood.com/content/movie/a9e4b78c-02e0-4e8c-8f2c-e5b158525b41/poster-780.jpg',
  },
  {
    title: `The Godfather Part II`,
    youtubeUrl: 'https://www.youtube.com/watch?v=9O1Iy9od7-A',
    poster: 'https://img.reelgood.com/content/movie/bf7fff60-ead5-44bd-89bc-4839ea690a0d/poster-780.jpg',
  },
  {
    title: `The Green Mile`,
    youtubeUrl: 'https://www.youtube.com/watch?v=Ki4haFrqSrw',
    poster: 'https://img.reelgood.com/content/movie/35369a71-ef65-4c62-a147-2df8a76e7aa1/poster-780.jpg',
  },
  {
    title: `Raiders of the Lost Ark`,
    youtubeUrl: 'https://www.youtube.com/watch?v=XkkzKHCx154',
    poster: 'https://img.reelgood.com/content/movie/4a3ae2dd-b85f-4a01-8440-7209fabd9e62/poster-780.jpg',
  },
  {
    title: `The Prestige`,
    youtubeUrl: 'https://www.youtube.com/watch?v=o4gHCmTQDVI',
    poster: 'https://img.reelgood.com/content/movie/feb109d4-abf1-42dc-8b2f-070c7ac3805e/poster-780.jpg',
  },
  {
    title: `12 Angry Men`,
    youtubeUrl: 'https://www.youtube.com/watch?v=_13J_9B5jEk',
    poster: 'https://img.reelgood.com/content/movie/182897bd-7f35-4b16-a9d9-9dc6257e6a3d/poster-780.jpg',
  },
  {
    title: `Léon: The Professional`,
    youtubeUrl: 'https://www.youtube.com/watch?v=aNQqoExfQsg',
    poster: 'https://img.reelgood.com/content/movie/051ee91b-91a3-43bb-b0d2-2ba3c87f24db/poster-780.jpg',
  },
  {
    title: `The Departed`,
    youtubeUrl: 'https://www.youtube.com/watch?v=iojhqm0JTW4',
    poster: 'https://img.reelgood.com/content/movie/97f4d30a-d5d5-4e09-bf83-e48e13e179b5/poster-780.jpg',
  },
  {
    title: `Jurassic Park`,
    youtubeUrl: 'https://www.youtube.com/watch?v=lc0UehYemQA',
    poster: 'https://img.reelgood.com/content/movie/448af488-8079-44fa-8369-5fc412871ad5/poster-780.jpg',
  },
  {
    title: `Django Unchained`,
    youtubeUrl: 'https://www.youtube.com/watch?v=_iH0UBYDI4g',
    poster: 'https://img.reelgood.com/content/movie/4d2eadc4-5cfe-4657-8ff2-5739fd6243de/poster-780.jpg',
  },
  {
    title: `Batman Begins`,
    youtubeUrl: 'https://www.youtube.com/watch?v=vak9ZLfhGnQ',
    poster: 'https://img.reelgood.com/content/movie/5aef76cb-8dd0-4070-a8bc-7739c2e0962c/poster-780.jpg',
  },
  {
    title: `The Usual Suspects`,
    youtubeUrl: 'https://www.youtube.com/watch?v=oiXdPolca5w',
    poster: 'https://img.reelgood.com/content/movie/023335b3-3042-44aa-b1a1-7647ceb8ff7b/poster-780.jpg',
  },
  {
    title: `Spider-Man: Into the Spider-Verse`,
    youtubeUrl: 'https://www.youtube.com/watch?v=tg52up16eq0',
    poster: 'https://img.reelgood.com/content/movie/0f23615f-1811-48b7-8592-36c3122d92dd/poster-780.jpg',
  },
  {
    title: `Good Will Hunting`,
    youtubeUrl: 'https://www.youtube.com/watch?v=PaZVjZEFkRs',
    poster: 'https://img.reelgood.com/content/movie/c1f27fd6-ece9-46fd-9979-3806b12d3e69/poster-780.jpg',
  },
  {
    title: `Alien`,
    youtubeUrl: 'https://www.youtube.com/watch?v=LjLamj-b0I8',
    poster: 'https://img.reelgood.com/content/movie/fa2211fb-24ac-4f60-9a95-65a30a8f4710/poster-780.jpg',
  },
  {
    title: `Star Wars: Episode IV - A New Hope`,
    youtubeUrl: 'https://www.youtube.com/watch?v=vZ734NWnAHA',
    poster: 'https://img.reelgood.com/content/movie/3f768b1a-297d-418c-8f90-1c05d7b57b98/poster-780.jpg',
  },
  {
    title: `Inglourious Basterds`,
    youtubeUrl: 'https://www.youtube.com/watch?v=KnrRy6kSFF0',
    poster: 'https://img.reelgood.com/content/movie/7cedfcc4-594c-4927-ac68-af156fd002a4/poster-780.jpg',
  },
  {
    title: `Die Hard`,
    youtubeUrl: 'https://www.youtube.com/watch?v=2TQ-pOvI6Xo',
    poster: 'https://img.reelgood.com/content/movie/84b95ba3-43d4-4c03-8475-e6e3d97bb760/poster-780.jpg',
  },
  {
    title: `Memento`,
    youtubeUrl: 'https://www.youtube.com/watch?v=0vS0E9bBSL0',
    poster: 'https://img.reelgood.com/content/movie/5bc0f1d6-3972-4c5c-abc1-0f5afbd6f6a7/poster-780.jpg',
  },
  {
    title: `Indiana Jones and the Last Crusade`,
    youtubeUrl: 'https://www.youtube.com/watch?v=a6JB2suJYHM',
    poster: 'https://img.reelgood.com/content/movie/2ddbe3b1-4c36-4c86-abb5-da83038db42f/poster-780.jpg',
  },
  {
    title: `Aliens`,
    youtubeUrl: 'https://www.youtube.com/watch?v=sVwH0hIvV5k',
    poster: 'https://img.reelgood.com/content/movie/1e0cdbc4-df9c-4ab9-9437-6b7f7dedf370/poster-780.jpg',
  },
  {
    title: `American History X`,
    youtubeUrl: 'https://www.youtube.com/watch?v=XfQYHqsiN5g',
    poster: 'https://img.reelgood.com/content/movie/2d298e25-b57f-4f37-bf46-04287b0afcfc/poster-780.jpg',
  },
  {
    title: `Saving Private Ryan`,
    youtubeUrl: 'https://www.youtube.com/watch?v=9CiW_DgxCnQ',
    poster: 'https://img.reelgood.com/content/movie/5dea9c93-9e1a-4acc-bc3e-dc2c8a3c6d04/poster-780.jpg',
  },
  {
    title: `City of God`,
    youtubeUrl: 'https://www.youtube.com/watch?v=ioUE_5wpg_E',
    poster: 'https://img.reelgood.com/content/movie/69cde1b5-4e4f-4df2-a1fe-5f7955daebc1/poster-780.jpg',
  },
  {
    title: `Life Is Beautiful`,
    youtubeUrl: 'https://www.youtube.com/watch?v=pAYEQP8gx3w',
    poster: 'https://img.reelgood.com/content/movie/933df3e9-2e4b-4cc0-b4a1-dac7e4a4e2c1/poster-780.jpg',
  },
  {
    title: `It's a Wonderful Life`,
    youtubeUrl: 'https://www.youtube.com/watch?v=ewe4lg8zTYA',
    poster: 'https://img.reelgood.com/content/movie/9dfce59c-0e4d-435a-8c5a-3e0b97958a15/poster-780.jpg',
  },
  {
    title: `Spirited Away`,
    youtubeUrl: 'https://www.youtube.com/watch?v=ByXuk9QqQkk',
    poster: 'https://img.reelgood.com/content/movie/8e6329a2-b76c-4db4-87b0-af1cd71d234b/poster-780.jpg',
  },
  {
    title: `Psycho`,
    youtubeUrl: 'https://www.youtube.com/watch?v=Wz719b9QUqY',
    poster: 'https://img.reelgood.com/content/movie/6ec4cf1c-cb43-42e4-8c2a-fdd2de3c8a3c/poster-780.jpg',
  },


  {
    title: `The Silence of the Lambs`,
    youtubeUrl: 'https://www.youtube.com/watch?v=W6Mm8Sbe__o',
    poster: 'https://img.reelgood.com/content/movie/9c5d013f-b3e1-4c12-921c-3b2d69e4f51e/poster-780.jpg',
  },
  {
    title: `Modern Times`,
    youtubeUrl: 'https://www.youtube.com/watch?v=GLeDdzGUTq0',
    poster: 'https://img.reelgood.com/content/movie/3b4c5d6e-7f8g-9h0i-1j2k-3l4m5n6o7p8q/poster-780.jpg',
  },
  {
    title: `The Pianist`,
    youtubeUrl: 'https://www.youtube.com/watch?v=BFwGqLa_oAo',
    poster: 'https://img.reelgood.com/content/movie/31a919f0-ebc8-4b4f-b7cf-35ea85064320/poster-780.jpg',
  },
  {
    title: `The Lion King`,
    youtubeUrl: 'https://www.youtube.com/watch?v=4sj1MT05lAA',
    poster: 'https://img.reelgood.com/content/movie/8c5e1f2a-3b4c-5d6e-7f8g-9h0i1j2k3l4m/poster-780.jpg',
  },
  {
    title: `WALL·E`,
    youtubeUrl: 'https://www.youtube.com/watch?v=alIq_wG9FNk',
    poster: 'https://img.reelgood.com/content/movie/8f7e6d5c-4b3a-2c1d-0e9f-8a7b6c5d4e3f/poster-780.jpg',
  },

  {
    title: `The Shining`,
    youtubeUrl: 'https://www.youtube.com/watch?v=S014oGZiSdI',
    poster: 'https://img.reelgood.com/content/movie/5d4c3b2a-1f0e-9d8c-7b6a-5f4e3d2c1b0a/poster-780.jpg',
  },
  {
    title: `Dr. Strangelove or: How I Learned to Stop Worrying and Love the Bomb`,
    youtubeUrl: 'https://www.youtube.com/watch?v=jPU1AYTxwg4',
    poster: 'https://img.reelgood.com/content/movie/84f4be87-9a4c-4d44-af7d-c11c9a80af8f/poster-780.jpg',
  },
  {
    title: `Apocalypse Now`,
    youtubeUrl: 'https://www.youtube.com/watch?v=IkrhkUeDCdQ',
    poster: 'https://img.reelgood.com/content/movie/1a2b3c4d-5e6f-7g8h-9i0j-1k2l3m4n5o6p/poster-780.jpg',
  },
  {
    title: `Braveheart`,
    youtubeUrl: 'https://www.youtube.com/watch?v=nMft5QDOHek',
    poster: 'https://img.reelgood.com/content/movie/7195fb3c-76ab-4298-a22e-44b3a8c44aaf/poster-780.jpg',
  },
  {
    title: `Cinema Paradiso`,
    youtubeUrl: 'https://www.youtube.com/watch?v=C2-GX0Tltgw',
    poster: 'https://img.reelgood.com/content/movie/4i5j6k7l-8m9n-0o1p-2q3r-4s5t6u7v8w9x/poster-780.jpg',
  },
  {
    title: `Oldboy`,
    youtubeUrl: 'https://www.youtube.com/watch?v=2HkjrJ6IK5E',
    poster: 'https://img.reelgood.com/content/movie/8a7b6c5d-4e3f-2g1h-0i9j-8k7l6m5n4o3p/poster-780.jpg',
  },
  {
    title: `Princess Mononoke`,
    youtubeUrl: 'https://www.youtube.com/watch?v=4OiMOHRDs14',
    poster: 'https://img.reelgood.com/content/movie/6k7l8m9n-0o1p-2q3r-4s5t-6u7v8w9x0y1z/poster-780.jpg',
  },
  {
    title: `Eternal Sunshine of the Spotless Mind`,
    youtubeUrl: 'https://www.youtube.com/watch?v=yE-f1alkq9I',
    poster: 'https://img.reelgood.com/content/movie/2b3c4d5e-6f7g-8h9i-0j1k-2l3m4n5o6p7q/poster-780.jpg',
  },
  {
    title: `Amélie`,
    youtubeUrl: 'https://www.youtube.com/watch?v=HUECWi5pX7o',
    poster: 'https://img.reelgood.com/content/movie/8h9i0j1k-2l3m-4n5o-6p7q-8r9s0t1u2v3w/poster-780.jpg',
  },
  {
    title: `Toy Story`,
    youtubeUrl: 'https://www.youtube.com/watch?v=v-PjgYDrg70',
    poster: 'https://img.reelgood.com/content/movie/a0b1c2d3-e4f5-6g7h-8i9j-0k1l2m3n4o5p/poster-780.jpg',
  },
  {
    title: `Coco`,
    youtubeUrl: 'https://www.youtube.com/watch?v=xlnPHQ3TLX8',
    poster: 'https://img.reelgood.com/content/movie/4c5d6e7f-8g9h-0i1j-2k3l-4m5n6o7p8q9r/poster-780.jpg',
  },
  {
    title: `Zootopia`,
    youtubeUrl: 'https://www.youtube.com/watch?v=jWM0ct-OLsM',
    poster: 'https://img.reelgood.com/content/movie/2a22f989-e42b-40fc-8a43-4d673144ef21/poster-780.jpg',
  },
  {
    title: `Avengers: Infinity War`,
    youtubeUrl: 'https://www.youtube.com/watch?v=6ZfuNTqbHE8',
    poster: 'https://img.reelgood.com/content/movie/ef45a1f7-faab-4bca-baa2-6784c37f4ae9/poster-780.jpg',
  },
  {
    title: `Avengers: Endgame`,
    youtubeUrl: 'https://www.youtube.com/watch?v=TcMBFSGVi1c',
    poster: 'https://img.reelgood.com/content/movie/5eef3e86-5e4b-466b-92f0-1c3c2de3c8a3/poster-780.jpg',
  },
  {
    title: `Joker`,
    youtubeUrl: 'https://www.youtube.com/watch?v=zAGVQLHvwOY',
    poster: 'https://img.reelgood.com/content/movie/2df8026a-77fa-4d61-b72d-f5f0c2941b8e/poster-780.jpg',
  },
  {
    title: `Parasite`,
    youtubeUrl: 'https://www.youtube.com/watch?v=5xH0HfJHsaY',
    poster: 'https://img.reelgood.com/content/movie/043e0617-6490-449e-8789-53e7f5379b37/poster-780.jpg',
  },
  {
    title: `The Dark Knight Rises`,
    youtubeUrl: 'https://www.youtube.com/watch?v=g8evyE9TuYk',
    poster: 'https://img.reelgood.com/content/movie/8m9n0o1p-2q3r-4s5t-6u7v-8w9x0y1z2a3b/poster-780.jpg',
  },
  {
    title: `Star Wars: Episode V - The Empire Strikes Back`,
    youtubeUrl: 'https://www.youtube.com/watch?v=JNwNXF9Y6kY',
    poster: 'https://img.reelgood.com/content/movie/685c8898-1e0e-473d-82d2-8f972b26090c/poster-780.jpg',
  },
  {
    title: `Terminator 2: Judgment Day`,
    youtubeUrl: 'https://www.youtube.com/watch?v=CRRlbK5w8AE',
    poster: 'https://img.reelgood.com/content/movie/3g2f1e0d-c9b8-7a6f-5e4d-3c2b1a0f9e8d/poster-780.jpg',
  },
  {
    title: `Grave of the Fireflies`,
    youtubeUrl: 'https://www.youtube.com/watch?v=4vPeTSRd580',
    poster: 'https://img.reelgood.com/content/movie/2g3h4i5j-6k7l-8m9n-0o1p-2q3r4s5t6u7v/poster-780.jpg',
  },
  {
    title: `The Intouchables`,
    youtubeUrl: 'https://www.youtube.com/watch?v=34WIbmXkewU',
    poster: 'https://img.reelgood.com/content/movie/534c933c-df1b-41cd-8b59-0404b3f2df44/poster-780.jpg',
  },

  {
    title: `Rear Window`,
    youtubeUrl: 'https://www.youtube.com/watch?v=6kCcZCMYw38',
    poster: 'https://img.reelgood.com/content/movie/e9a1b0b3-0d2e-44df-bfaa-f9a316bed36b/poster-780.jpg',
  },
  {
    title: `The Great Escape`,
    youtubeUrl: 'https://www.youtube.com/watch?v=xkwmIDx9RwQ',
    poster: 'https://img.reelgood.com/content/movie/7e6f5d4c-3b2a-1c0d-9e8f-7a6b5c4d3e2f/poster-780.jpg',
  },


  {
    title: `A Clockwork Orange`,
    youtubeUrl: 'https://www.youtube.com/watch?v=SPRzm8ibDQ8',
    poster: 'https://img.reelgood.com/content/movie/1b2c3d4e-5f6g-7h8i-9j0k-1l2m3n4o5p6q/poster-780.jpg',
  },
  {
    title: `Full Metal Jacket`,
    youtubeUrl: 'https://www.youtube.com/watch?v=n2i917l5RFc',
    poster: 'https://img.reelgood.com/content/movie/3d4e5f6g-7h8i-9j0k-1l2m-3n4o5p6q7r8s/poster-780.jpg',
  },

  {
    title: `The Third Man`,
    youtubeUrl: 'https://www.youtube.com/watch?v=2oEsWi88Qv0',
    poster: 'https://img.reelgood.com/content/movie/5f6g7h8i-9j0k-1l2m-3n4o-5p6q7r8s9t0u/poster-780.jpg',
  },
  {
    title: `Requiem for a Dream`,
    youtubeUrl: 'https://www.youtube.com/watch?v=lgo3Hb5vWLE',
    poster: 'https://img.reelgood.com/content/movie/6g7h8i9j-0k1l-2m3n-4o5p-6q7r8s9t0u1v/poster-780.jpg',
  },
  {
    title: `Monty Python and the Holy Grail`,
    youtubeUrl: 'https://www.youtube.com/watch?v=WcsobLUkrQg',
    poster: 'https://img.reelgood.com/content/movie/7h8i9j0k-1l2m-3n4o-5p6q-7r8s9t0u1v2w/poster-780.jpg',
  },
  {
    title: `The Truman Show`,
    youtubeUrl: 'https://www.youtube.com/watch?v=dlnmQbPGuls',
    poster: 'https://img.reelgood.com/content/movie/8i9j0k1l-2m3n-4o5p-6q7r-8s9t0u1v2w3x/poster-780.jpg',
  },
  {
    title: `The Big Lebowski`,
    youtubeUrl: 'https://www.youtube.com/watch?v=cd-go0oBF4Y',
    poster: 'https://img.reelgood.com/content/movie/9j0k1l2m-3n4o-5p6q-7r8s-9t0u1v2w3x4y/poster-780.jpg',
  },
  {
    title: `Blade Runner`,
    youtubeUrl: 'https://www.youtube.com/watch?v=eogpIG53Cis',
    poster: 'https://img.reelgood.com/content/movie/6915ecfa-a825-40d0-9807-aa9ea4339e17/poster-780.jpg',
  },

  {
    title: `There Will Be Blood`,
    youtubeUrl: 'https://www.youtube.com/watch?v=FeSLPELpMeM',
    poster: 'https://img.reelgood.com/content/movie/1c2d3e4f-5g6h-7i8j-9k0l-1m2n3o4p5q6r/poster-780.jpg',
  },
  {
    title: `No Country for Old Men`,
    youtubeUrl: 'https://www.youtube.com/watch?v=38A__WT3-o0',
    poster: 'https://img.reelgood.com/content/movie/2d3e4f5g-6h7i-8j9k-0l1m-2n3o4p5q6r7s/poster-780.jpg',
  },
  {
    title: `The Sixth Sense`,
    youtubeUrl: 'https://www.youtube.com/watch?v=VG9AGf66tXM',
    poster: 'https://img.reelgood.com/content/movie/3e4f5g6h-7i8j-9k0l-1m2n-3o4p5q6r7s8t/poster-780.jpg',
  },
  {
    title: `The Thing`,
    youtubeUrl: 'https://www.youtube.com/watch?v=5ftmr17M-a4',
    poster: 'https://img.reelgood.com/content/movie/4f5g6h7i-8j9k-0l1m-2n3o-4p5q6r7s8t9u/poster-780.jpg',
  },
  {
    title: `Fargo`,
    youtubeUrl: 'https://www.youtube.com/watch?v=h2tY82z3xXU',
    poster: 'https://img.reelgood.com/content/movie/5g6h7i8j-9k0l-1m2n-3o4p-5q6r7s8t9u0v/poster-780.jpg',
  },


  {
    title: `The Terminator`,
    youtubeUrl: 'https://www.youtube.com/watch?v=k64P4l2Wmeg',
    poster: 'https://img.reelgood.com/content/movie/9k0l1m2n-3o4p-5q6r-7s8t-9u0v1w2x3y4z/poster-780.jpg',
  },
  {
    title: `Taxi Driver`,
    youtubeUrl: 'https://www.youtube.com/watch?v=UUxD4-dEzn0',
    poster: 'https://img.reelgood.com/content/movie/0l1m2n3o-4p5q-6r7s-8t9u-0v1w2x3y4z5a/poster-780.jpg',
  },
  {
    title: `Vertigo`,
    youtubeUrl: 'https://www.youtube.com/watch?v=Z5jvQwwHQNY',
    poster: 'https://img.reelgood.com/content/movie/1m2n3o4p-5q6r-7s8t-9u0v-1w2x3y4z5a6b/poster-780.jpg',
  },



  {
    title: `Pan's Labyrinth`,
    youtubeUrl: 'https://www.youtube.com/watch?v=EqYiSlkvRuw',
    poster: 'https://img.reelgood.com/content/movie/9u0v1w2x-3y4z-5a6b-7c8d-9e0f1g2h3i4j/poster-780.jpg',
  },
  {
    title: `Trainspotting`,
    youtubeUrl: 'https://www.youtube.com/watch?v=8LuxOYIpu-I',
    poster: 'https://img.reelgood.com/content/movie/0v1w2x3y-4z5a-6b7c-8d9e-0f1g2h3i4j5k/poster-780.jpg',
  },
  {
    title: `Annie Hall`,
    youtubeUrl: 'https://www.youtube.com/watch?v=OqVgCfZX-yE',
    poster: 'https://img.reelgood.com/content/movie/1w2x3y4z-5a6b-7c8d-9e0f-1g2h3i4j5k6l/poster-780.jpg',
  },
  {
    title: `Groundhog Day`,
    youtubeUrl: 'https://www.youtube.com/watch?v=GncQtURdcE4',
    poster: 'https://img.reelgood.com/content/movie/2x3y4z5a-6b7c-8d9e-0f1g-2h3i4j5k6l7m/poster-780.jpg',
  },
  {
    title: `The Wizard of Oz`,
    youtubeUrl: 'https://www.youtube.com/watch?v=H_3T4DGw10U',
    poster: 'https://img.reelgood.com/content/movie/3y4z5a6b-7c8d-9e0f-1g2h-3i4j5k6l7m8n/poster-780.jpg',
  },
  {
    title: `The Exorcist`,
    youtubeUrl: 'https://www.youtube.com/watch?v=YDGw1MTEe9k',
    poster: 'https://img.reelgood.com/content/movie/4z5a6b7c-8d9e-0f1g-2h3i-4j5k6l7m8n9o/poster-780.jpg',
  },

  {
    title: `Double Indemnity`,
    youtubeUrl: 'https://www.youtube.com/watch?v=yKrrAa2o9Eg',
    poster: 'https://img.reelgood.com/content/movie/1g2h3i4j-5k6l-7m8n-9o0p-1q2r3s4t5u6v/poster-780.jpg',
  },

];
isMuted = true;
isPlaying = false;
videoLoaded = false;
videoCurrentTime = 0;
videoDuration = 0;
played = false;
showPlayOverlay = true;
private hidePlayOverlayTimeout?: ReturnType<typeof setTimeout>;
private previousShouldShowOverlay?: boolean;
private swipeOnboardingTimeout: ReturnType<typeof setTimeout> | null = null;
private swipeOnboardingCloseTimeout: ReturnType<typeof setTimeout> | null = null;
private swipeOnboardingStyleEl: HTMLStyleElement | null = null;
private swipeOnboardingOverlayEl: HTMLDivElement | null = null;
private isUserSeekingRange = false;
private pendingSeekValue = 0;
private playbackSyncTimer?: ReturnType<typeof setInterval>;
private playbackLogTimer?: ReturnType<typeof setInterval>;
private playbackTick = 0;
private activeSlideIndex = 0;
private playerReady = false;
private readonly playerMessageHandler = (event: MessageEvent) => {
  let payload: any;
  if (typeof event.data === 'string') {
    try {
      payload = JSON.parse(event.data);
    } catch {
      return;
    }
  } else if (typeof event.data === 'object' && event.data !== null) {
    payload = event.data;
  } else {
    return;
  }
/*
  console.log('[lk-film-studios] raw iframe message event:', {
    origin: event.origin,
    data: event.data,
  });
  */

  const fromKnownFrame = this.isMessageFromKnownFrame(event.source);
  if (!fromKnownFrame && payload?.event !== 'infoDelivery') return;

  const info = payload?.info;

  if (payload?.event === 'onReady') {
    this.playerReady = true;
    this.requestPlaybackInfo();
  }

 // console.log('[lk-film-studios] parsed iframe payload:', payload);

  this.ngZone.run(() => {
    if (typeof info?.playerState === 'number') {
      this.isPlaying = info.playerState === 1;
      if (info.playerState === 1) {
        this.played = true;
      }
    }

    // YouTube can deliver duration either as info.duration (object payload)
    // or as a numeric info value for getDuration responses.
    const rawDuration = typeof info?.duration === 'number'
      ? info.duration
      : (payload?.func === 'getDuration' && typeof info === 'number' ? info : undefined);

    const parsedLengthSeconds = Number(info?.videoData?.lengthSeconds);
    const durationValue = Number.isFinite(rawDuration) && rawDuration > 0
      ? rawDuration
      : (Number.isFinite(parsedLengthSeconds) && parsedLengthSeconds > 0 ? parsedLengthSeconds : undefined);

    //console.log('[lk-film-studios] fetched duration candidate:', durationValue, 'raw info:', info);

    if (typeof durationValue === 'number' && durationValue > 0) {
      this.videoDuration = durationValue;
      console.log('[lk-film-studios] current video duration (seconds):', this.videoDuration);
    }

    if (typeof info?.currentTime === 'number' && !Number.isNaN(info.currentTime) && !this.isUserSeekingRange) {
      this.videoCurrentTime = info.currentTime;
    }
/*
    console.log('[lk-film-studios] video data snapshot:', {
      playerState: info?.playerState,
      currentTime: info?.currentTime,
      duration: durationValue,
      videoData: info?.videoData,
      payloadEvent: payload?.event,
      payloadFunc: payload?.func,
      payloadId: payload?.id,
      knownFrame: fromKnownFrame,
    });
    */
  });
};
@ViewChildren('ytFrame') ytFrames!: QueryList<ElementRef<HTMLIFrameElement>>;
web;
displayed_trailers;
  constructor(private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
       private router: Router,
       private ngZone: NgZone,
       private formservice: FormServiceService,
       private utils: Utils,
       private navigationState: AppNavigationStateService,

  ) {}

ngOnInit(): void {
this.route.queryParamMap.subscribe(params => {
    const flag = params.get('mobile');
    const isMobileMode = flag === 'true';

  

            		if (isMobileMode) {
      this.web=false;
		}else{
   
		}
      });
          this.web=true;
  this.trailers = this.shuffleTrailers(this.trailers);
		this.trailers[0].embedUrl = this.buildEmbedUrl(
    this.trailers[0].youtubeUrl,
    1,      // autoplay ON for first one (if needed)
    true    // init mode
  );
this.displayed_trailers = this.trailers.slice(0, this.batchSize);
this.isPlaying = true;
this.played = true;
this.videoCurrentTime = 0;
this.videoDuration = 0;
  

}
ngDoCheck(): void {
  const shouldShowOverlay = !(this.isPlaying && this.played);

  if (this.previousShouldShowOverlay === shouldShowOverlay) {
    return;
  }

  this.previousShouldShowOverlay = shouldShowOverlay;

  if (shouldShowOverlay) {
    if (this.hidePlayOverlayTimeout) {
      clearTimeout(this.hidePlayOverlayTimeout);
      this.hidePlayOverlayTimeout = undefined;
    }
    this.showPlayOverlay = true;
    return;
  }

  if (this.hidePlayOverlayTimeout) {
    clearTimeout(this.hidePlayOverlayTimeout);
  }

  this.hidePlayOverlayTimeout = setTimeout(() => {
    this.showPlayOverlay = false;
    this.hidePlayOverlayTimeout = undefined;
  }, 300);
}

ngAfterViewInit(){
    setTimeout(async () => {
      this.bindDesktopWheelSwipe();
      this.bindMobileTouchSwipe();
      this.startPlaybackSync();
      this.tryLaunchGlobalSwipeOnboarding();
    }, 360);
}
private bindDesktopWheelSwipe() {
  const el = this.slidesEl?.nativeElement as HTMLElement;
  if (!el || !this.slides) {
    return;
  }

  const onWheel = async (e: WheelEvent) => {
    await this.handleWheelNavigation(e);
  };

  el.addEventListener('wheel', onWheel, { passive: false });
  this.wheelCleanup = () => el.removeEventListener('wheel', onWheel as EventListener);
}

private bindMobileTouchSwipe() {
  const el = this.slidesEl?.nativeElement as HTMLElement;
  if (!el || !this.slides) {
    return;
  }

  const isNativeMobile = ['ios', 'android'].includes(Capacitor.getPlatform());
  const isTouchDevice = typeof window !== 'undefined' && window.matchMedia?.('(pointer: coarse)').matches;

  if (!isNativeMobile && !isTouchDevice) {
    return;
  }

  const onTouchStart = (event: TouchEvent) => {
    if (!event.touches?.length) {
      return;
    }
    this.touchStartY = event.touches[0].clientY;
    this.touchCurrentY = this.touchStartY;
  };

  const onTouchMove = (event: TouchEvent) => {
    if (!event.touches?.length || this.touchStartY === null) {
      return;
    }

    this.touchCurrentY = event.touches[0].clientY;
    const delta = this.touchStartY - this.touchCurrentY;

    if (Math.abs(delta) > 8) {
      event.preventDefault();
    }
  };

  const onTouchEnd = async () => {
    await this.handleTouchSwipeNavigation();
  };

  const onTouchCancel = () => {
    this.touchStartY = null;
    this.touchCurrentY = null;
  };

  el.addEventListener('touchstart', onTouchStart, { passive: true });
  el.addEventListener('touchmove', onTouchMove, { passive: false });
  el.addEventListener('touchend', onTouchEnd, { passive: true });
  el.addEventListener('touchcancel', onTouchCancel, { passive: true });

  this.touchCleanup = () => {
    el.removeEventListener('touchstart', onTouchStart as EventListener);
    el.removeEventListener('touchmove', onTouchMove as EventListener);
    el.removeEventListener('touchend', onTouchEnd as EventListener);
    el.removeEventListener('touchcancel', onTouchCancel as EventListener);
  };
}

private async handleTouchSwipeNavigation() {
  if (!this.slides || this.touchStartY === null || this.touchCurrentY === null) {
    this.touchStartY = null;
    this.touchCurrentY = null;
    return;
  }

  const deltaY = this.touchStartY - this.touchCurrentY;
  this.touchStartY = null;
  this.touchCurrentY = null;

  if (Math.abs(deltaY) < 30) {
    return;
  }

  this.removeGlobalSwipeOnboarding();

  if (this.wheelLock) {
    return;
  }
  this.wheelLock = true;

  if (deltaY > 0) {
    await this.slides.slideNext();
  } else {
    await this.slides.slidePrev();
  }

  setTimeout(() => (this.wheelLock = false), 330);
}

async onDesktopWheel(event: WheelEvent) {
  await this.handleWheelNavigation(event);
}

private async handleWheelNavigation(event: WheelEvent) {
  event.preventDefault();
  event.stopPropagation();

  this.removeGlobalSwipeOnboarding();

  if (this.wheelLock || !this.slides) return;
  this.wheelLock = true;

  const dx = event.deltaX;
  const dy = event.deltaY;
  const amount = Math.abs(dx) > Math.abs(dy) ? dx : dy;

  if (amount > 24) {
    await this.slides.slideNext();
  } else if (amount < -24) {
    await this.slides.slidePrev();
  }

  setTimeout(() => (this.wheelLock = false), 330);
}

@HostListener('document:click')
@HostListener('document:touchstart')
onPageInteraction(): void {
  this.removeGlobalSwipeOnboarding();
}

ngOnDestroy(): void {
  this.removeGlobalSwipeOnboarding();
  this.stopPlaybackSync();
  window.removeEventListener('message', this.playerMessageHandler);
  if (this.wheelCleanup) {
    this.wheelCleanup();
    this.wheelCleanup = undefined;
  }
  if (this.touchCleanup) {
    this.touchCleanup();
    this.touchCleanup = undefined;
  }
  if (this.hidePlayOverlayTimeout) {
    clearTimeout(this.hidePlayOverlayTimeout);
    this.hidePlayOverlayTimeout = undefined;
  }
}
private tryLaunchGlobalSwipeOnboarding() {
  if (this.formservice.showed_onbarding_swipe_lkfilm || this.formservice.globalSwipeOnboardingShown) {
    return;
  }

  this.formservice.showed_onbarding_swipe_lkfilm = true;
  this.launchGlobalSwipeOnboarding();
}

private async launchGlobalSwipeOnboarding() {
  if (typeof document === 'undefined') {
    return;
  }

  if (this.formservice.globalSwipeOnboardingShown) {
    return;
  }

  this.formservice.globalSwipeOnboardingShown = true;
  const shouldShowOnboarding = await this.utils.consumeOneTimeFlag('global_swipe_onboarding_shown');
  if (!shouldShowOnboarding) {
    return;
  }

  this.removeGlobalSwipeOnboarding(true);

  const style = document.createElement('style');
  style.id = 'lk-global-swipe-onboarding-style';
  style.textContent = `
    .lk-global-swipe-onboarding {
      position: fixed;
      inset: 0;
      z-index: 2147483646;
      background: #f6f6f6;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      animation: lkPagePeek 1.8s ease-in-out infinite;
      transform: translateY(0);
      will-change: transform;
    }

    .lk-global-swipe-onboarding.lk-exit {
      animation: lkExitToTop 420ms ease-in forwards !important;
    }

    .lk-global-swipe-onboarding__title {
      position: absolute;
      top: 14vh;
      margin: 0;
      text-align: center;
      font-size: clamp(34px, 7vw, 46px);
      line-height: 1.05;
      font-weight: 800;
      color: #000;
    }

    .lk-global-swipe-onboarding__title span { display: block; }

    .lk-global-swipe-onboarding__card {
      width: 148px;
      height: 248px;
      border-radius: 28px;
      background: #bdbdbd;
      box-shadow: inset 0 3px 0 rgba(255,255,255,0.35);
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .lk-global-swipe-onboarding__play {
      width: 0;
      height: 0;
      border-top: 15px solid transparent;
      border-bottom: 15px solid transparent;
      border-left: 22px solid #e7e7e7;
      margin-left: 8px;
    }

    .lk-global-swipe-onboarding__pill {
      position: absolute;
      bottom: 12px;
      width: 26px;
      height: 3px;
      border-radius: 999px;
      background: #d9d9d9;
    }

    .lk-global-swipe-onboarding__hand {
      position: absolute;
      right: -52px;
      top: 112px;
      width: 84px;
      height: 84px;
      border-radius: 48px;
      border: 2px solid #222;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      animation: lkSwipeHand 1s ease-in-out infinite;
    }

    .lk-global-swipe-onboarding__hand ion-icon {
      font-size: 40px;
      color: #222;
    }

    .lk-global-swipe-onboarding__chevrons {
      position: absolute;
      bottom: 15vh;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .lk-global-swipe-onboarding__chevrons span {
      width: 10px;
      height: 10px;
      border-top: 2px solid #333;
      border-left: 2px solid #333;
      transform: rotate(45deg);
      opacity: 0;
      animation: lkChevronPulse 1s ease-in-out infinite;
    }

    .lk-global-swipe-onboarding__chevrons span:nth-child(2) { animation-delay: 0.15s; }
    .lk-global-swipe-onboarding__chevrons span:nth-child(3) { animation-delay: 0.3s; }

    @keyframes lkSwipeHand {
      0%,100% { transform: translate(0,0) scale(1); }
      35% { transform: translate(-8px,-16px) scale(0.98); }
    }

    @keyframes lkChevronPulse {
      0% { opacity: 0; transform: translateY(6px) rotate(45deg); }
      45% { opacity: 1; transform: translateY(-4px) rotate(45deg); }
      100% { opacity: 0; transform: translateY(-10px) rotate(45deg); }
    }
    @keyframes lkExitToTop {
      0% { transform: translateY(0); opacity: 1; }
      100% { transform: translateY(-100%); opacity: 1; }
    }

    @keyframes lkPagePeek {
      0%, 100% { transform: translateY(0); }
      50% { transform: translateY(-32px); }
    }
  `;

  const overlay = document.createElement('div');
  overlay.className = 'lk-global-swipe-onboarding';
  overlay.innerHTML = `
    <h2 class="lk-global-swipe-onboarding__title">Swipe up to start<span>watching</span></h2>
    <div class="lk-global-swipe-onboarding__card">
      <div class="lk-global-swipe-onboarding__play"></div>
      <div class="lk-global-swipe-onboarding__pill"></div>
      <div class="lk-global-swipe-onboarding__hand"><ion-icon name="hand-left-outline"></ion-icon></div>
    </div>
    <div class="lk-global-swipe-onboarding__chevrons" aria-hidden="true">
      <span></span><span></span><span></span>
    </div>
  `;

  document.head.appendChild(style);
  document.body.appendChild(overlay);

  this.swipeOnboardingStyleEl = style;
  this.swipeOnboardingOverlayEl = overlay as HTMLDivElement;

  this.swipeOnboardingTimeout = setTimeout(() => {
    this.removeGlobalSwipeOnboarding();
  }, 5300);
}

private removeGlobalSwipeOnboarding(immediate = false) {
  if (this.swipeOnboardingTimeout) {
    clearTimeout(this.swipeOnboardingTimeout);
    this.swipeOnboardingTimeout = null;
  }

  if (this.swipeOnboardingCloseTimeout) {
    clearTimeout(this.swipeOnboardingCloseTimeout);
    this.swipeOnboardingCloseTimeout = null;
  }

  const overlay = this.swipeOnboardingOverlayEl;

  if (overlay && !immediate && !overlay.classList.contains('lk-exit')) {
    overlay.classList.add('lk-exit');
    this.swipeOnboardingCloseTimeout = setTimeout(() => {
      this.removeGlobalSwipeOnboarding(true);
    }, 420);
    return;
  }

  if (overlay?.parentNode) {
    overlay.parentNode.removeChild(overlay);
  }
  this.swipeOnboardingOverlayEl = null;

  if (this.swipeOnboardingStyleEl?.parentNode) {
    this.swipeOnboardingStyleEl.parentNode.removeChild(this.swipeOnboardingStyleEl);
  }
  this.swipeOnboardingStyleEl = null;
}

private buildEmbedUrl(url: string, autoplay = 1, muted = true): SafeResourceUrl {
  const autoplayFlag = autoplay ? 1 : 0;
  const muteFlag = muted ? 1 : 0;

  const origin = encodeURIComponent(window.location.origin);
  const embedUrl = url
    .replace('watch?v=', 'embed/')
    .replace('youtu.be/', 'youtube-nocookie.com/embed/')
    + `?autoplay=${autoplayFlag}&mute=${muteFlag}&enablejsapi=1&playsinline=1&rel=0&modestbranding=1&origin=${origin}`;

  return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
}

getPlayControlIcon(): string {
  return this.isPlaying && this.played ? 'stop' : 'play';
}

formatTimeLabel = (value: number): string => {
  const time = Number.isFinite(value) && value > 0 ? value : 0;
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

get videoRangeMax(): number {
  return this.videoDuration >= 100 ? this.videoDuration : 100;
}

onFrameLoad(index: number) {
  this.videoLoaded = true;
  this.playerReady = false;
  const activeFrame = this.getActiveFrameElement();
  const win = activeFrame?.contentWindow;
  if (win) {
    this.sendListeningPing(win, activeFrame?.id || 'lk-film-studios-player');
  }

  if (index === this.activeSlideIndex) {
    this.isPlaying = true;
    this.played = true;
    this.forceUnmuteAndPlay();
    setTimeout(() => this.requestPlaybackInfo(), 120);
    setTimeout(() => this.requestPlaybackInfo(), 650);
  }
}
batchSize = 9;
youtube_url;
async onSlideDidChange() {
 this.played=true;
 this.isPlaying=true;
  this.isMuted=false;
  this.playerReady = false;
  this.videoLoaded = false;
  this.videoCurrentTime = 0;
  this.videoDuration = 0;
  const activeIndex = await this.slides.getActiveIndex();
  this.appendNextBatchIfNeeded(activeIndex);
   console.log('onSlideDidChange')
  // 1. Get the index of the newly active slide
  const idx = await this.slides?.getActiveIndex() ?? 0;
  this.activeSlideIndex = idx;

    this.youtube_url=this.displayed_trailers[idx];

  // 2. Safely check if a trailer exists at that index
  const activeTrailer = this.displayed_trailers[idx];

  if (activeTrailer) {
    // 3. Generate the new embed URL using the active trailer's URL and the value '1'
    const newEmbedUrl = this.buildEmbedUrl(activeTrailer.youtubeUrl, 1, false);
    console.log('newEmbedUrl',newEmbedUrl)
    // 4. Update the specific trailer object with the new URL
    //    We create a new array using map to ensure Angular/framework change detection picks it up.
    this.displayed_trailers = this.displayed_trailers.map((t, index) => {
      if (index === idx) {
        // This is the active slide: update its embedUrl

        
        return {
          ...t,
          embedUrl: newEmbedUrl,
        };
       
      }
      // Keep other slides mounted with poster only to avoid too many active iframes.
      return {
        ...t,
        embedUrl: null,
      };
    });

    setTimeout(() => {
      this.playFromJs();
    }, 260);
  }
}

private appendNextBatchIfNeeded(activeIndex: number) {
  const thresholdToPreload = 2;
  const nearEnd = activeIndex >= this.displayed_trailers.length - thresholdToPreload;
  if (!nearEnd) {
    return;
  }

  const alreadyLoaded = this.displayed_trailers.length;
  const nextBatch = this.trailers.slice(alreadyLoaded, alreadyLoaded + this.batchSize);
  if (nextBatch.length === 0) {
    return;
  }

  this.displayed_trailers = [...this.displayed_trailers, ...nextBatch];
}

private shuffleTrailers(trailers: TrailerItem[]): TrailerItem[] {
  const shuffled = [...trailers];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}





toggleMute() {
  this.applyMuteState(!this.isMuted);
}

togglePlayStop() {
  const func = this.isPlaying ? 'stopVideo' : 'playVideo';
  const activeFrame = this.getActiveFrameElement();
  if (!activeFrame) return;
  try {
    activeFrame.contentWindow?.postMessage(
      JSON.stringify({
        event: 'command',
        func,
        args: [],
      }),
      '*'
    );
  } catch (err) {
    console.error('[togglePlayStop] iframe error:', err);
  }

  this.isPlaying = !this.isPlaying;
  if (this.isPlaying) {
    this.played = true;
  }
}

onSeekInput(event: CustomEvent) {
  console.log('onSeekInput')
  const value = Number(event?.detail?.value ?? this.pendingSeekValue);
  if (!Number.isFinite(value)) return;

  this.videoCurrentTime = value;
  this.pendingSeekValue = value;

  // While dragging, seek continuously so the range actively controls playback.
  if (this.isUserSeekingRange) {
    this.seekToPendingValue();
  }
}

onSeekChange(event: CustomEvent) {
  console.log('onSeekChange')
  const value = Number(event?.detail?.value ?? 0);
  console.log('value', value)
  if (!Number.isFinite(value)) return;
  this.videoCurrentTime = value;
  this.pendingSeekValue = value;

  // Click/tap on the bar can emit ionChange without knob drag events.
  if (!this.isUserSeekingRange) {
    this.seekToPendingValue();
  }
}

onIonKnobMoveStart(event) {
  console.log('onSeekStart')
  this.isUserSeekingRange = true;
   this.seekToPendingValue();
}

onIonKnobMoveEnd(event: CustomEvent) {
      console.log('onSeekEnd',this.videoCurrentTime)
 this.pendingSeekValue = this.videoCurrentTime;
  /*const value = Number(event?.detail?.value ?? this.pendingSeekValue);
      console.log('onSeekEnd',value)
  if (Number.isFinite(value)) {
    this.pendingSeekValue = value;
    this.videoCurrentTime = value;
  }
    */
  this.seekToPendingValue();
}

private seekToPendingValue() {
  const activeFrame = this.getActiveFrameElement();
  if (!activeFrame) return;
  try {
    activeFrame.contentWindow?.postMessage(
      JSON.stringify({
        event: 'command',
        func: 'seekTo',
        args: [this.pendingSeekValue, true],
      }),
      '*'
    );
  } catch (err) {
    console.error('[onSeekChange] iframe error:', err);
    return;
  }

  // Pull fresh time/duration values after seeking so ion-range stays in sync.
  this.requestPlaybackInfo();
  setTimeout(() => this.requestPlaybackInfo(), 120);
}

goNext() { this.slides.slideNext(); }
  goPrev() { this.slides.slidePrev(); }


  async onBack(): Promise<void> {
    this.displayed_trailers=null;
    const fallback = this.navigationState.backFallbackForCurrentRoute(this.router.url);
    const didNavigate = await this.router.navigateByUrl(fallback, { replaceUrl: true });
    if (!didNavigate) {
      await this.router.navigateByUrl('/home/ecosystem-page', { replaceUrl: true });
    }
  }
  playFromJs() {
  console.log('[playFromJs] called');

  this.forceUnmuteAndPlay();
  this.played = true;
  this.isPlaying = true;
}

private forceUnmuteAndPlay() {
  this.applyMuteState(false);
  this.postToActiveFrame('playVideo', []);

  // Retry a few times because YouTube iframe may ignore the first command
  // while it is still bootstrapping after a slide change.
  setTimeout(() => {
    this.applyMuteState(false);
    this.postToActiveFrame('playVideo', []);
  }, 200);

  setTimeout(() => {
    this.applyMuteState(false);
    this.postToActiveFrame('playVideo', []);
  }, 600);
}

private startPlaybackSync() {
  window.addEventListener('message', this.playerMessageHandler);
  if (this.playbackSyncTimer) {
    clearInterval(this.playbackSyncTimer);
  }
  if (this.playbackLogTimer) {
    clearInterval(this.playbackLogTimer);
  }
  this.playbackTick = 0;
  this.requestPlaybackInfo();

  this.playbackSyncTimer = setInterval(() => {
    this.playbackTick += 1;
    if (this.playbackTick % 2 === 0) {
      this.requestPlaybackInfo();
    }
  }, 250);

  this.playbackLogTimer = setInterval(() => {
    this.requestCurrentTime();
  }, 1000);
}

private stopPlaybackSync() {
  if (this.playbackSyncTimer) {
    clearInterval(this.playbackSyncTimer);
    this.playbackSyncTimer = undefined;
  }
  if (this.playbackLogTimer) {
    clearInterval(this.playbackLogTimer);
    this.playbackLogTimer = undefined;
  }
}

private sendListeningPing(win: Window, frameId: string) {
  try {
    win.postMessage(
      JSON.stringify({
        event: 'listening',
        id: frameId,
        channel: 'widget',
      }),
      '*'
    );
  } catch (err) {
    console.error('[sendListeningPing] iframe error:', err);
  }
}

private requestPlaybackInfo() {
  const activeFrame = this.getActiveFrameElement();
  const win = activeFrame?.contentWindow;
  if (!win) return;
  const frameId = activeFrame?.id || 'lk-film-studios-player';

  try {
    this.sendListeningPing(win, frameId);

    if (!this.playerReady) {
      return;
    }

    win.postMessage(
      JSON.stringify({
        event: 'command',
        func: 'addEventListener',
        args: ['onStateChange'],
      }),
      '*'
    );

    win.postMessage(
      JSON.stringify({
        event: 'command',
        func: 'getCurrentTime',
        args: [],
      }),
      '*'
    );

    win.postMessage(
      JSON.stringify({
        event: 'command',
        func: 'getDuration',
        args: [],
      }),
      '*'
    );

    win.postMessage(
      JSON.stringify({
        event: 'command',
        func: 'getVideoData',
        args: [],
      }),
      '*'
    );

    win.postMessage(
      JSON.stringify({
        event: 'command',
        func: 'getPlayerState',
        args: [],
      }),
      '*'
    );
  } catch (err) {
    console.error('[requestPlaybackInfo] iframe error:', err);
  }
}

private requestCurrentTime() {
  if (!this.videoLoaded || !this.playerReady) return;
  const activeFrame = this.getActiveFrameElement();
  const win = activeFrame?.contentWindow;
  if (!win) return;

  try {
    win.postMessage(
      JSON.stringify({
        event: 'command',
        func: 'getCurrentTime',
        args: [],
      }),
      '*'
    );
    if (this.isPlaying && !this.isUserSeekingRange) {
      const nextTime = this.videoCurrentTime + 1;
      this.videoCurrentTime = this.videoDuration > 0
        ? Math.min(nextTime, this.videoDuration)
        : nextTime;
    }
   // console.log('[lk-film-studios] video currentTime (1s):', this.videoCurrentTime);
  } catch (err) {
    console.error('[requestCurrentTime] iframe error:', err);
  }
}

private getActiveFrameElement(): HTMLIFrameElement | null {
  const frames = this.ytFrames?.toArray() ?? [];
  if (frames.length === 0) return null;

  // Only the active slide has embedUrl, so the rendered iframe list usually contains one item.
  return frames[0].nativeElement;
}

private getActiveFrameWindow(): Window | null {
  return this.getActiveFrameElement()?.contentWindow ?? null;
}

private isMessageFromKnownFrame(source: MessageEventSource | null): boolean {
  if (!source) return false;
  const frames = this.ytFrames?.toArray() ?? [];
  if (frames.length === 0) return false;
  return frames.some(frameRef => frameRef.nativeElement.contentWindow === source);
}

private postToActiveFrame(func: string, args: any[] = []) {
  const activeFrame = this.getActiveFrameElement();
  const win = activeFrame?.contentWindow;
  if (!win || !this.playerReady) return;

  try {
    win.postMessage(
      JSON.stringify({
        event: 'command',
        func,
        args,
      }),
      '*'
    );
  } catch (err) {
    console.error(`[postToActiveFrame] ${func} iframe error:`, err);
  }
}

private applyMuteState(shouldMute: boolean) {
  this.isMuted = shouldMute;
  this.postToActiveFrame(shouldMute ? 'mute' : 'unMute', []);
}

}
